import { Box, Icon, Spinner } from '@amzn/awsui-components-core';
import {
  ContentAccessUser,
  ContentWorkflow,
  ReviewRequestStatus,
  UserProfile,
  UserRoles,
} from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import ReviewRequestActionButtons from './ReviewRequestActionButtons';

interface Props {
  workflow: ContentWorkflow;
  userProfile: UserProfile;
}

let mplServiceClient: IMplServiceClient;

const ReviewRequestStatusColumn: React.FunctionComponent<Props> = ({
  workflow,
  userProfile,
}: Props) => {
  const { contentId } = workflow;
  const { userId } = userProfile;
  const [isAccepted, setIsAccepted] = useState<boolean>(false);
  const [isDeclined, setIsDeclined] = useState<boolean>(false);
  const [isAlreadyDeclined, setIsAlreadyDeclined] = useState<boolean>(false);
  const [isReviewer, setIsReviewer] = useState<boolean>();
  const [isLoading, setIsLoading] = useState<boolean>(true); // TODO: handle loading

  useEffect(() => {
    mplServiceClient = MplServiceClientFactory.create();
    const shouldShowStatusColumn = async () => {
      setIsLoading(true);
      setIsAccepted(false);
      setIsDeclined(false);
      setIsAlreadyDeclined(false);
      setIsReviewer(false);
      const { accessUsers } = await mplServiceClient.listContentReviewers(contentId);
      // check if is assigned peer reviewer of this content
      const isPeerReviewer = (accessUsers as ContentAccessUser[]).some(
        (user) => user.userId === userId,
      );
      setIsReviewer(isPeerReviewer);
      if (isPeerReviewer) {
        // check if pending or accepted
        const status = ((accessUsers || []) as ContentAccessUser[]).find(
          (user) => user.userId === userId,
        )?.reviewRequestStatus;
        if (status === ReviewRequestStatus.ACCEPTED) {
          setIsAccepted(true);
        }
      }
      setIsLoading(false);
    };
    shouldShowStatusColumn();
  }, [contentId, userId]);

  const handleAccept = () => {
    setIsAccepted(true);
  };
  const handleDecline = () => {
    setIsDeclined(true);
  };
  const handleAlreadyDeclined = () => {
    setIsAlreadyDeclined(true);
  };

  const acceptedLabel = (
    <Box float="right">
      <Icon name="status-positive" variant="success" /> Accepted review request
    </Box>
  );
  const declinedLabel = (
    <Box float="right">
      <Icon name="status-negative" /> Declined review request
    </Box>
  );
  const alreadyDeclinedLabel = (
    <Box float="right">
      <Icon name="status-info" /> Already declined
    </Box>
  );

  const pendingButtons = isReviewer ? (
    <ReviewRequestActionButtons
      workflow={workflow}
      onAccept={handleAccept}
      onDecline={handleDecline}
      handleActionError={handleAlreadyDeclined}
    />
  ) : null;

  const loadingSpinner = (
    <Box float="right">
      <Spinner size="normal" />
    </Box>
  );

  let statusColumn = pendingButtons;

  if (isLoading) {
    statusColumn = loadingSpinner;
  } else if (isAlreadyDeclined) {
    statusColumn = alreadyDeclinedLabel;
  } else if (isDeclined) {
    statusColumn = declinedLabel;
  } else if (isAccepted) {
    statusColumn = acceptedLabel;
  }
  return statusColumn;
};

export default ReviewRequestStatusColumn;
